import styled from 'styled-components';

import BG from '@assets/images/promotions/participants.webp';
import GradientBG from '@assets/images/promotions/participants_gradient.webp';

export const Wrapper = styled.div`
	padding: 24px;
	position: relative;
	overflow: hidden;
	border-radius: 16px;

	background-image: url('${GradientBG}');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: right;

	@media (max-width: 992px) {
		padding: 16px;
	}

	&:after {
		content: '';
		position: absolute;
		z-index: 10;
		width: 100%;
		height: 100%;
		bottom: 0;
		right: 0;
		background-image: url('${BG}');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: right bottom;

		@media (max-width: 992px) {
			background-size: 150px;
		}
	}
`;

export const Content = styled.div`
	position: relative;
	z-index: 20;
`;

export const Title = styled.h3`
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	margin-bottom: 24px;

	@media (max-width: 992px) {
		font-size: 24px;
		line-height: 33px;
		margin-bottom: 16px;
	}
`;

export const ParticipantsCountRow = styled.div`
	display: flex;
	gap: 8px;
	margin-bottom: 24px;

	@media (max-width: 992px) {
		margin-bottom: 16px;
	}
`;

export const ParticipantsText = styled.p`
	margin: 0;
	font-size: 24px;
	line-height: 33px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		font-size: 20px;
		line-height: 27px;
	}
`;

export const ParticipantsCount = styled.p`
	margin: 0;
	font-size: 24px;
	line-height: 33px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	@media (max-width: 992px) {
		font-size: 20px;
		line-height: 27px;
	}
`;
